var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer mobile-fixed"},[_c('div',{staticClass:"footer-links",staticStyle:{"margin-bottom":"5px"}},[_c('a',{staticStyle:{"text-decoration":"none","color":"#0066cc"},attrs:{"href":"/privacy.html","target":"_blank"}},[_vm._v("개인정보 처리방침")])]),_c('div',{staticClass:"copyright"},[_vm._v(" © 2025 ZONE5. All rights reserved. ")])])
}]

export { render, staticRenderFns }